import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=1c0ee0bd&scoped=true&"
import script from "./CouponItem.vue?vue&type=script&lang=ts&"
export * from "./CouponItem.vue?vue&type=script&lang=ts&"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=1c0ee0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ee0bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c0ee0bd')) {
      api.createRecord('1c0ee0bd', component.options)
    } else {
      api.reload('1c0ee0bd', component.options)
    }
    module.hot.accept("./CouponItem.vue?vue&type=template&id=1c0ee0bd&scoped=true&", function () {
      api.rerender('1c0ee0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CouponItem.vue"
export default component.exports